function normalizeCharacterId(characterId) {
  return String(characterId || "honeybadger")
    .toLowerCase()
    .replace(/[^a-z]/g, "");
}

export const CHARACTER_PROFILES = [
  {
    id: "honeybadger",
    icon: "🦡",
    name: "HONEY BADGER",
    ship: "RAGEBURROW Mk IV",
    archetype: "Elon Musk archetype",
    species: "Honey Badger",
    playstyle: "Aggressive, no brakes, high damage",
    bio:
      "A volatility addict in a burnt-orange ramship. Accelerates forever, solves problems by colliding with them, and calls it leadership.",
    quote: "Pick me if you hate plans!\nBrakes are cowardice!",
    stats: { speed: 70, health: 80, damage: 15 },
    special: "UNHINGED VECTOR: ram-through strike window",
    personality: { aggression: 95, equity: 10, stability: 20, chaos: 90 },
  },
  {
    id: "octopus",
    icon: "🐙",
    name: "OCTOPUS",
    ship: "MULTIVEIL",
    archetype: "Sam Altman archetype",
    species: "Octopus",
    playstyle: "Strategic, drones, adaptive",
    bio:
      "A calm operator with eight simultaneous side-projects. Delegates risk to drones, negotiates with lasers, and always asks for the cap table.",
    quote: "Excellent choice.\nI selected myself hours ago.",
    stats: { speed: 40, health: 120, damage: 10 },
    special: "DISTRIBUTED PRESENCE: deploy full 8-drone formation",
    personality: { aggression: 30, equity: 90, stability: 80, chaos: 10 },
  },
  {
    id: "elephant",
    icon: "🐘",
    name: "ELEPHANT",
    ship: "GRAY MATTER",
    archetype: "Dario Amodei archetype",
    species: "Elephant",
    playstyle: "Tanky, slow, methodical",
    bio:
      "A safety-first juggernaut. Slow to turn, hard to kill, and absolutely certain your plan needs more modeling before impact.",
    quote: "A prudent decision.\nPlease sign waiver forms.",
    stats: { speed: 30, health: 150, damage: 20 },
    special: "MEASURED CHARGE: windup then empowered shot",
    personality: { aggression: 20, equity: 70, stability: 95, chaos: 5 },
  },
  {
    id: "mantisshrimp",
    icon: "🦐",
    name: "MANTIS SHRIMP",
    ship: "CHROMA WAR",
    archetype: "Alex Karp archetype",
    species: "Mantis Shrimp",
    playstyle: "Stealth, high damage, philosophical",
    bio:
      "An iridescent menace who disappears into the quarterly fog. Strikes from stealth, speaks in metaphors, and treats the battlefield like a board meeting.",
    quote: "Selection is merely delayed destiny.",
    stats: { speed: 60, health: 70, damage: 25 },
    special: "SPECTRAL STRIKE: cloak shell + damage spike",
    personality: { aggression: 60, equity: 40, stability: 50, chaos: 70 },
  },
  {
    id: "ant",
    icon: "🐜",
    name: "ANT",
    ship: "FULFILLMENT QUEEN",
    archetype: "Jeff Bezos archetype",
    species: "Ant",
    playstyle: "Swarm deployment, logistics",
    bio:
      "A logistics machine in a shipping-container battleship. Builds a swarm, optimizes throughput, and turns your defeat into a deliverable.",
    quote: "Ready.\nConfirmed.",
    stats: { speed: 50, health: 100, damage: 12 },
    special: "SWARM CHAIN: surge swarm and shield logistics",
    personality: { aggression: 40, equity: 95, stability: 70, chaos: 20 },
  },
];

export function getCharacterProfile(characterId) {
  const id = normalizeCharacterId(characterId);
  return CHARACTER_PROFILES.find((c) => c.id === id) || null;
}

export function getDefaultCharacterId() {
  return "honeybadger";
}
